import React, { useState, useEffect } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'

function ArrangeParagraphComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd
  } = props
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Answers,
    Score,
    AnswerColorFill,
    Background,
    Description,
    QuestionColorFill,
    AnswerFontSize,
    QuestionFontSize,
    Opacity,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    FontStyle,
    Italic,
    Bold
  } = mcData

  const [actualArray, setActualArray] = useState([])
  const [selectedArray, setSelectedArray] = useState([])
  const [shuffledArray, setShuffledArray] = useState([])
  const [sentence, setSentence] = useState([])
  const [selectedItem, setSelectedItem] = useState(-1)

  useEffect(() => {
    const optionsValues = Answers[0].Option
    let splitedArrayCopy = optionsValues.split(' ')
    setActualArray(splitedArrayCopy)
    setSentence(splitedArrayCopy)
    if (defaultValue) {
      let defaultValueSelected = defaultValue.CtlValue.selectedArray
      setSelectedArray(defaultValueSelected)
      setShuffledArray(defaultValue.CtlValue.remainingArray)
    } else {
      setShuffledArray(blindShuffle(splitedArrayCopy))
      setSelectedArray([])
    }
  }, [defaultValue])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, selectedArray, shuffledArray)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick) {
      if (JSON.stringify(sentence) === JSON.stringify(selectedArray)) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }, [explanationClick])

  function handleSelect(selectedAnswer, selectedIndex) {
    onAttemptChange(1)
    if (sentence.length !== selectedArray.length) {
      const refreshedShuffledArray = shuffledArray.filter(
        (item, index) => index !== selectedIndex
      )
      let selectedArrayCopy = [...selectedArray]
      selectedArrayCopy.push(selectedAnswer)
      setSelectedArray(selectedArrayCopy)
      setShuffledArray(refreshedShuffledArray)
      validateCorrectAnswer(false, selectedArrayCopy, refreshedShuffledArray)
    }
    if (selectedAnswer === actualArray[selectedArray.length]) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
  }

  function handleUnSelect(unSelectedAnswer, unSelectedIndex) {
    if (selectedArray.length !== 0) {
      const refreshedSelectedArray = selectedArray.filter(
        (item, index) => index !== unSelectedIndex
      )
      setSelectedArray(refreshedSelectedArray)
      let shuffledArrayCopy = [...shuffledArray]
      shuffledArrayCopy.push(unSelectedAnswer)
      setShuffledArray(shuffledArrayCopy)
      validateCorrectAnswer(false, refreshedSelectedArray, shuffledArrayCopy)
    }
  }

  function validateCorrectAnswer(
    timerValue,
    refreshedSelectedArray,
    shuffledArrayCopy
  ) {
    let ctlValueCopy = {
      selectedArray: refreshedSelectedArray,
      remainingArray: shuffledArrayCopy
    }
    if (JSON.stringify(sentence) === JSON.stringify(refreshedSelectedArray)) {
      onValueChange(ControlID, ctlValueCopy, Score, Score, '', timerValue)
    } else {
      onValueChange(ControlID, ctlValueCopy, 0, Score, '', timerValue)
    }
    setSelectedItem(-1)
  }

  return (
    <div
      className='slide-comp-wrapper'
      style={{
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      {!isVerifyMode && (
        <div className='arrange-ques-cont'>
          {shuffledArray &&
            shuffledArray.map((item, index) => {
              const replacedItem = item.replaceAll('^', ' ')
              return (
                <p
                  className='arrange-ques-label default-border'
                  key={index.toString()}
                  style={{
                    backgroundColor: AnswerFillColor,
                    color: AnswerColorFill,
                    fontSize:
                      AnswerFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : AnswerFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    animationName:
                      selectedItem === index ? 'zoom-out' : 'unset',
                    animationDuration: '200ms',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (completed === 0 && isActive) {
                      setSelectedItem(index)
                      handleSelect(item, index)
                    }
                  }}
                >
                  {replacedItem}
                </p>
              )
            })}
        </div>
      )}
      {!isVerifyMode ? (
        <div className='arrange-ans-cont '>
          {selectedArray &&
            selectedArray.map((item, index) => {
              const replacedItem = item.replaceAll('^', ' ')
              return (
                <p
                  key={index.toString()}
                  className={
                    isPractice || completed === 1 || !isActive
                      ? item === actualArray[index]
                        ? 'arrange-ans-label right-border'
                        : 'arrange-ans-label wrong-border'
                      : 'arrange-ans-label default-border'
                  }
                  style={{
                    backgroundColor: AnswerFillColor,
                    color: AnswerColorFill,
                    fontSize:
                      AnswerFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : AnswerFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    animationName:
                      selectedItem === index
                        ? 'zoom-out'
                        : isPractice || completed === 1
                        ? item === actualArray[index]
                          ? 'pulse_animation'
                          : 'shake_animation'
                        : 'zoom-in',
                    animationDuration: '200ms',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (completed === 0 && isActive) {
                      setSelectedItem(index)
                      handleUnSelect(item, index)
                    }
                  }}
                >
                  {replacedItem}
                </p>
              )
            })}
        </div>
      ) : (
        <div
          style={{
            width: '80%',
            flexDirection: 'row',
            minHeight: '40px',
            //maxWidth: "95%",
            overflowWrap: 'break-word',
            backgroundColor: '#ffffff80',
            borderRadius: '10px',
            alignSelf: 'center'
          }}
        >
          {sentence &&
            sentence.map((item, index) => {
              const replacedItem = item.replaceAll('^', ' ')
              return (
                <p
                  key={index.toString()}
                  style={{
                    backgroundColor: AnswerFillColor,
                    justifyContent: 'center',
                    padding: '10px',
                    margin: '5px',
                    width: 'fit-content',
                    display: 'inline-flex',
                    borderRadius: '10px',
                    borderWidth: '2px',
                    borderColor: '#0bff31',
                    borderStyle: 'solid',
                    color: AnswerColorFill,
                    fontSize:
                      AnswerFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : AnswerFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    cursor: 'pointer',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (completed === 0 && isActive) {
                      handleUnSelect(item, index)
                    }
                  }}
                >
                  {replacedItem}
                </p>
              )
            })}
        </div>
      )}
    </div>
  )
}

export default ArrangeParagraphComponent
